const config = {
    production: true,
    // apiBaseUrl: 'http://localhost:4000/api',
    apiBaseUrl: 'https://8m02o9way6.execute-api.us-east-1.amazonaws.com/prod/api',
    defaultPageSize: 100,
    endpoints: {
        Login : '/company/login',
        Signup: '/company/signup',
        ContactUs: '/admin/send-contactUs-email',
        BookDemo: '/admin/send-bookDemo-email',
        // Add other endpoints here as needed
        
    }
};

export default config;